import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { LanguageProvider, type Dict, type Lang } from './utils/i18n';

interface AppProps {
  initialLang?: Lang;
  initialDict?: Dict;
}

export default function App({ initialLang, initialDict }: AppProps) {
  return (
    <LanguageProvider initialLang={initialLang} initialDict={initialDict}>
      {/* Commit history changes synchronously so a new URL is never painted
          with the previous route's H1 or structured data. */}
      <BrowserRouter useTransitions={false}>
        <AppRoutes />
      </BrowserRouter>
    </LanguageProvider>
  );
}
